var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1051,
    viewBox: "0 0 1512 1051",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_254_2265)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.947,
    cy: 223.249,
    rx: 261.947,
    ry: 223.249,
    transform: "matrix(-0.337596 0.941291 -0.861442 -0.507856 1835 226.757)",
    fill: "url(#paint0_radial_254_2265)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_254_2265)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.529,
    cy: 269.929,
    rx: 213.529,
    ry: 269.929,
    transform: "matrix(0.977661 -0.210186 0.129685 0.991555 -177 456.701)",
    fill: "url(#paint1_radial_254_2265)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_254_2265)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.529,
    cy: 269.929,
    rx: 213.529,
    ry: 269.929,
    transform: "matrix(0.977661 -0.210186 0.129685 0.991555 961.848 354.5)",
    fill: "url(#paint2_radial_254_2265)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_254_2265",
    x: 1242.53,
    y: -11.5054,
    width: 623.45,
    height: 742.904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_254_2265"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_254_2265",
    x: -244.942,
    y: 308.041,
    width: 623.414,
    height: 742.858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_254_2265"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_254_2265",
    x: 893.906,
    y: 205.839,
    width: 623.414,
    height: 742.858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_254_2265"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_254_2265",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.947 223.249) rotate(90) scale(223.249 261.947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552885,
    stopColor: "#957BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_254_2265",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.529 269.929) rotate(90) scale(269.929 213.529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552885,
    stopColor: "#6F5CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_254_2265",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.529 269.929) rotate(90) scale(269.929 213.529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E08A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552885,
    stopColor: "#FFD149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbs);
export default __webpack_public_path__ + "static/media/Orbs.f0c70721f0597744aa6e682e146ad77c.svg";
export { ForwardRef as ReactComponent };